import React, { useState } from "react";
import { Row, Col, Image } from "antd";

const GalleryGrid = ({ gallery }) => {
  const [visible, setVisible] = useState(false);

  // Extract image URLs from API response
  const imageData = gallery[0]?.images?.map(
    (img) => `${process.env.REACT_APP_API_URL}${img.url} `
  ) || [];
  
   
  return (
    <>
      {/* Hidden Preview Group */}
      <div style={{ display: "none" }}>
        <Image.PreviewGroup
          preview={{ visible, onVisibleChange: (vis) => setVisible(vis) }}
        >
          {imageData.map((src, index) => (
            <Image src={src} key={index} />
          ))}
        </Image.PreviewGroup>
      </div>

      {/* Grid showing only 3 images + "See All" overlay */}
      <Row className="mt-12" gutter={[12, 12]}>
        {imageData.slice(0, 3).map((src, index) => (
          <Col xs={12} key={index}>
            <Image
              width="100%"
              src={src}
              alt={`Photo ${index}`}
              className="w-full !h-[140px] max-h-[140px] rounded-[10px] object-cover"
            />
          </Col>
        ))}

        {/* "See All" Tile */}
        <Col xs={12}>
          <div
            onClick={() => setVisible(true)}
            style={{
              position: "relative",
              height: "140px",
              borderRadius: "12px",
              overflow: "hidden",
              backgroundImage: `url('${imageData[0]}')`,
              backgroundSize: "cover",
              backgroundPosition: "center",
              cursor: "pointer",
            }}
          >
            <div className="absolute inset-0 bg-[linear-gradient(180deg,_#222222_0%,_rgba(20,20,20,0)_100%)] text-white flex items-center justify-center flex-col text-[14px] font-medium">
              <span>See All</span>
              <span>Client Reviews</span>
              <span>& Photos</span>
            </div>
          </div>
        </Col>
      </Row>
    </>
  );
};

export default GalleryGrid;
